import { RoleData } from './RoleData';
import { IAccountData } from './server/model/IAccountData';

export class AccountData {
    Id?: string;
    ConcurrencyStamp?: string;
    IsActive?: boolean;
    FirstName?: string;
    LastName?: string;
    UserName?: string;
    IsAccountAdmin?: boolean;
    TromanRoles: RoleData;
    ValmanRoles: RoleData;
    Created?: string; // TODO:TS should be date
    
    name?: string;

    constructor(json: IAccountData) {
        if (json) {
            this.Id = json.Id;
            this.ConcurrencyStamp = json.ConcurrencyStamp;
            this.IsActive = json.IsActive;
            this.FirstName = json.FirstName;
            this.LastName = json.LastName;
            this.UserName = json.UserName;
            this.Created = json.Created;
            this.IsAccountAdmin = json.Permissions.IsAccountAdmin;

            this.TromanRoles = new RoleData(json.Permissions.TromanRoles);
            this.ValmanRoles = new RoleData(json.Permissions.ValmanRoles);

            if (this.LastName != null) {
                if (this.FirstName != null) {
                    this.name = this.FirstName + ' ' + this.LastName;
                } else {
                    this.name = this.LastName;
                }
            } else {
                this.name = this.UserName;
            }
        } else {
            this.TromanRoles = new RoleData();
            this.ValmanRoles = new RoleData();
        }
    }

    toJSON() {
        const result: Partial<IAccountData> = {
            Id: this.Id,
            ConcurrencyStamp: this.ConcurrencyStamp,
            IsActive: this.IsActive,
            UserName: this.UserName,
            FirstName: this.FirstName,
            LastName: this.LastName,
            Created: this.Created,
            Permissions: {
                IsAccountAdmin: !!this.IsAccountAdmin,
                TromanRoles: this.TromanRoles,
                ValmanRoles: this.ValmanRoles,
            }
        };
        return result;
    }
}